<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.text-center {
  text-align: center;
}
.div-center {
  margin: 0px auto;
}
.content-title {
  font-size: 24px;
  margin-top: 20px;
  .border {
    border: 1px solid #000;
    margin: 10px 0px;
  }
}
.fontsize24 {
  font-size: 24px;
}
.fontsize26 {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue